import {
  Component,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../../vertical/sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { NgFor, NgForOf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ModalPricingService } from 'src/app/services/modal-pricing.service';
import { Roles } from '../../shared/Enums';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profileCategory {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link?: string;
  action?: () => void;
  needsSubscription?: boolean,
  showToRole?: string[]
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-horizontal-header',
  standalone: true,
  imports: [RouterModule, TablerIconsModule, MaterialModule, BrandingComponent, NgFor, SharedModule],
  templateUrl: './header.component.html',
})
export class AppHorizontalHeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  user?: User;
  filteredProfileCategories: profileCategory[] = [];
  userRole: string = ""
  public showFreeTrialValue = false;
  progress: number = 0

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    public modalPricingService: ModalPricingService
  ) {

    this.user = userService.user

    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.formatUserRole()
    this.filteredProfileCategories = this.profileCategories.filter(profile => {
      const hasSubscription = !profile.needsSubscription || !!this.user.subscriptionID;
      const roleAllowed = profile.showToRole.includes(this.userRole);

      return hasSubscription && roleAllowed;
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  formatUserRole() {
    if (this.user.role === Roles.ROLE_DISTRIBUTOR) {
      this.userRole = "Distributor"
    }

    if (this.user.role === Roles.ROLE_CLINIC) {
      this.userRole = "Clinic"
    }

    if (this.user.role === Roles.ROLE_CUSTOMER) {
      this.userRole = "Client"
    }

  }

  logout() {
    this.authService.logout();
  }

  // changeLanguage(lang: any): void {
  //   this.translate.use(lang.code);
  //   this.selectedLanguage = lang;
  // }

  // notifications: notifications[] = [
  //   {
  //     id: 1,
  //     img: '/assets/images/profile/user-1.jpg',
  //     title: 'Roman Joined the Team!',
  //     subtitle: 'Congratulate him',
  //   },
  //   {
  //     id: 2,
  //     img: '/assets/images/profile/user-2.jpg',
  //     title: 'New message received',
  //     subtitle: 'Salma sent you new message',
  //   },
  //   {
  //     id: 3,
  //     img: '/assets/images/profile/user-3.jpg',
  //     title: 'New Payment received',
  //     subtitle: 'Check your earnings',
  //   },
  //   {
  //     id: 4,
  //     img: '/assets/images/profile/user-4.jpg',
  //     title: 'Jolly completed tasks',
  //     subtitle: 'Assign her new tasks',
  //   },
  //   {
  //     id: 5,
  //     img: '/assets/images/profile/user-5.jpg',
  //     title: 'Roman Joined the Team!',
  //     subtitle: 'Congratulate him',
  //   },
  // ];

  profileCategories: profileCategory[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'PROFILE_CATEGORIES.MY_PROFILE',
      subtitle: 'PROFILE_CATEGORIES.ACCOUNT_SETTINGS',
      link: '/account-settings',
      needsSubscription: false,
      showToRole: ['Distributor']
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-office-bag.svg',
      title: 'PROFILE_CATEGORIES.BILLING',
      subtitle: 'PROFILE_CATEGORIES.MANAGE_BILLING',
      action: () => this.showStripeBilling(),
      needsSubscription: true,
      showToRole: ['Distributor']
    },
    {
      id: 3,
      img: '/assets/images/svgs/faq.png',
      title: 'PROFILE_CATEGORIES.FAQ',
      subtitle: 'PROFILE_CATEGORIES.FREQUENTLY_ASKED_QUESTIONS',
      action: () => this.openFAQ(),
      needsSubscription: false,
      showToRole: ['Distributor', 'Client', 'Clinic']
    },
  ];

  apps: apps[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-dd-chat.svg',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'eCommerce App',
      subtitle: 'Buy a Product',
      link: '/',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/',
    },
    {
      id: 4,
      img: '/assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/',
    },
    {
      id: 5,
      img: '/assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/',
    },
    {
      id: 6,
      img: '/assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/',
    },
    {
      id: 7,
      img: '/assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/',
    },
    {
      id: 8,
      img: '/assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/',
    },
  ];

  startFreeTrial() {
    this.userService.updateUserFreeTrial().subscribe((user) => {
      window.location.reload();
    })
  }

  calculateRemainingDays() {
    const TRIAL_PERIOD_LENGTH = 15

    const trialStartedAt = new Date(this.user.trialStartedAt);

    const trialEndDate = new Date(trialStartedAt);
    trialEndDate.setDate(trialEndDate.getDate() + TRIAL_PERIOD_LENGTH);

    const currentDate = new Date();
    const remainingDuration = trialEndDate.getTime() - currentDate.getTime();

    const remainingDays = Math.ceil(remainingDuration / (1000 * 60 * 60 * 24));

    if (remainingDays <= 0) {
      this.progress = 100
    } else {
      const daysPassed = TRIAL_PERIOD_LENGTH - remainingDays;
      this.progress = (daysPassed / TRIAL_PERIOD_LENGTH) * 100;
      this.progress = Math.round(this.progress)
    }

    return remainingDays;
  }

  handleClick(category: profileCategory): void {
    if (category.action) {
      // Ejecuta la acción personalizada si está definida
      category.action();
    } else if (category.link) {
      // Navega a la ruta especificada si no hay acción personalizada
      this.router.navigateByUrl(category.link);
    }
  }

  showStripeBilling() {
    this.userService.getPortalSession()
  }

  openFAQ(): void {
    window.open('/faq');
  }

}

@Component({
  selector: 'app-search-dialog',
  standalone: true,
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule, NgForOf],
  templateUrl: 'search-dialog.component.html',
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}